import { render, staticRenderFns } from "./EventDetailsContent.vue?vue&type=template&id=3b044edd&scoped=true&"
import script from "./EventDetailsContent.vue?vue&type=script&lang=ts&"
export * from "./EventDetailsContent.vue?vue&type=script&lang=ts&"
import style0 from "./EventDetailsContent.vue?vue&type=style&index=0&id=3b044edd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b044edd",
  null
  
)

export default component.exports